export type Entitlement = {
  key: string;
  enabled: boolean;
};

export enum EntitlementsModules {
  // Light plan
  RESIDENTS = 'RESIDENTS',
  ROOMS = 'ROOMS',
  TASKS = 'TASKS',
  USERS = 'USERS',
  SETTINGS = 'SETTINGS',

  // Plus plan
  EVENTS = 'EVENTS',
  INVENTORY = 'INVENTORY',
  MEDIA = 'MEDIA',
  MEDICATION = 'MEDICATION',

  // Max plan
  MEDICATION_DISPENSING = 'MEDICATION_DISPENSING',
  HEALTH_LOG = 'HEALTH_LOG',
  INVENTORY_REPORTING = 'INVENTORY_REPORTING',
  RELATIVES = 'RELATIVES',
  WORK_TIME = 'WORK_TIME',
  WORK_SCHEDULE = 'WORK_SCHEDULE',

  // Root for superadmin - dev tools and client management
  ROOT = 'ROOT',
}

export type ClientWithEntitlements = {
  id: string;
  clientName: string;
  entitlements: Entitlement[];
};
